/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 *
 */

/**
 * @module bulb-caption/bulbcaption
 */

import { Plugin } from 'ckeditor5';
// eslint-disable-next-line import/no-cycle
import BulbCaptionEditing from './bulbcaptionediting';
// TODO CG:
// import 'ckeditor5/ckeditor5-image/theme/imagecaption.css';
// import 'ckeditor5/ckeditor5.css';

/**
 * The general caption plugin.
 *
 * @extends Plugin
 */
export default class BulbCaption extends Plugin {

  /**
   * @inheritDoc
   */
  public static get requires() {
    return [BulbCaptionEditing] as const;
  }

  /**
   * @inheritDoc
   */
  public static get pluginName() {
    return 'BulbCaption' as const;
  }
}
